'use client';

/**
 * アクセスログを記録するAPI関数
 * NextJS API Route経由でRails側の /api/v2/access_logs エンドポイントを呼び出す
 */
export const createAccessLog = async (): Promise<void> => {
  try {
    const response = await fetch('/api/nextjs_api/access-logs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // セッション情報を含める
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `HTTP error! status: ${response.status}, message: ${
          errorData.error || 'Unknown error'
        }`,
      );
    }

    const data = await response.json();
    console.log('Access log recorded:', data.message);
  } catch (error) {
    console.error('Error recording access log:', error);
    throw error;
  }
};
